// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__ARoon","choiceBoxes":"toolbarselects_choiceBoxes__3jFIF","simpleField":"toolbarselects_simpleField__2NZz-"};